import React, {useEffect, useState } from "react";
import { 
    // getLoggedInUser, 
    getMyTasks, deleteTask } from "../../utils/helper";
import { Link } from "react-router-dom/cjs/react-router-dom";
import Loader from "../../utils/Loader";
import { useHistory } from "react-router-dom";
import { alertError, alertSuccess } from "../../utils/alerts";

export default function Tasks() {
    const [loading, setLoading] = useState(false);
    const [tasks, setTasks] = useState(null);
    const history = useHistory();
    // const [profile, setProfile] = useState(null);
    // const TOKEN = localStorage.getItem("kloka:token:data");

    useEffect(() => {
        setLoading(true);
        getMyTasks()
            .then((res) => { 
                setTasks(res.data.data);  
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            })
            .catch((err) => {
                console.log(err.response)
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            });
    }, []);

    // useEffect(() => {
    //     getLoggedInUser(TOKEN).then((res) => {
    //         setProfile(res.data.data);
    //     });
    // }, [TOKEN]);

    // console.log(profile)

    // const isTeamHead = (profile && profile.team?.team_head) ? profile.team?.team_head === profile._id : false;

    const navigateById = (path, id) => {
        history.push(`${path}/${id}`);
    };

    const handleDeleteOpen = (kpdid) => {
        if (
            window.confirm(
                "Note: This is an irreversible action. Click OK to continue."
            )
        ) {
            deleteTask(kpdid)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                    } else {
                        alertError(res.data.message)
                    }
                    window.location.reload();
                })
                .catch((err) => {
                    alertError(err.response.data.error);
                });
        } else {
            alert("Task delete canceled!");
        }
    };

    return (
        <>
            <div className="spur-card-menu"><Link to="/performance/create-task" className="pull-right btn topbtn btn-primary">CREATE TASK</Link></div>
            
            <h1 className="dash-title">Performance Management</h1>

            <div className="row dash-row">
                
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">Daily Tasks</div>
                        </div>
                        <div className="card-body">
                            <div className="my_profile">
                                {(!loading && tasks && tasks) ? 
                                    <div className="table-responsive">
                                        {(tasks && tasks.length > 0) ?
                                        <table className="table text-left text-caps table-bordered" id="myTable">
                                            <thead><tr><th>SN</th>
                                                {/* {isTeamHead ? <th>&nbsp;</th> : null} */}
                                                <th>Project/KPI</th><th>Task</th><th>Description</th><th>Year</th><th>Month</th><th>Week</th>
                                            <th>Status</th><th>View</th><th>Delete</th></tr></thead>
                                            <tbody>
                                                {tasks && tasks.map((row, index) => 
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        {/* {isTeamHead ? <td><input type="checkbox" name="" className="form-control" /></td> : null} */}
                                                        <td>{row?.task_kpi?.kpi && row?.task_kpi?.kpi}</td>
                                                        <td>{row?.task_title && row?.task_title}</td>
                                                        <td>{row?.task_description && row?.task_description}</td>
                                                        <td>{row?.year && row?.year}</td>
                                                        <td>{row?.month && row?.month}</td>
                                                        <td>{row?.week && row?.week}</td> 
                                                        <td><span className={row.status === "not started" ? 'badge badge-primary' : (
                                                            row.status === "in progress" ? 'badge badge-warning' : (
                                                                row.status === "finished" ? 'badge badge-success' : (
                                                                    row.status === "completed" ? 'badge badge-success' : (
                                                                        row.status === "reassigned" ? 'badge badge-secondary' : null
                                                                    )
                                                                )
                                                            )
                                                        )}>
                                                            {row.status && row.status}</span>
                                                        </td>
                                                        <td>
                                                            <button 
                                                                onClick={() => navigateById("/performance/task", row._id)} 
                                                                className='btn btn-preview'
                                                            >
                                                                    <i className="fa fa-eye"></i> View
                                                            </button>
                                                        </td>
                                                        <td>
                                                            <button 
                                                                onClick={() => handleDeleteOpen(row._id)} 
                                                                className='btn btn-delete'
                                                                disabled
                                                            >
                                                                <i className="fa fa-trash"></i> Delete
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table> : 
                                        <div className="alert alert-danger myerror d-block">You have not created any task yet.</div> }
                                    </div>
                                : <Loader /> }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
